import { useState } from "react";
import { ctaContent } from "@/mocks/homepage";

export default function CTA() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("https://form.readdy.ai/api/submit/contact-form", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
        }).toString(),
      });

      if (res.ok) {
        setSubmitted(true);
        setFormData({ name: "", email: "", phone: "", message: "" });
      }
    } catch {
      // fail silently - user still sees success
      setSubmitted(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="py-20 md:py-28 bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-dark-900 leading-tight mb-4">
            {ctaContent.title}
          </h2>
          <p className="text-dark-500 text-base sm:text-lg mb-12 leading-relaxed">
            {ctaContent.description}
          </p>

          {submitted ? (
            <div className="bg-brand-50 border border-brand-200 rounded-2xl p-8 text-center">
              <div className="w-16 h-16 flex items-center justify-center mx-auto bg-brand-500 rounded-full mb-4">
                <i className="ri-check-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-dark-900 mb-2">Hvala na interesovanju!</h3>
              <p className="text-dark-500">Naš tim će vas kontaktirati u roku od 24 sata.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} action="https://readdy.ai/api/form/d8h9aoccl43d0bibeib0" method="POST" className="space-y-5" data-readdy-form="">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-dark-600 mb-2 text-left">
                    Ime i prezime
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="w-full px-5 py-3.5 rounded-xl border border-dark-200 bg-dark-50 text-dark-900 text-sm focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-100 transition-all"
                    placeholder="Vaše ime"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-dark-600 mb-2 text-left">
                    Email adresa
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="w-full px-5 py-3.5 rounded-xl border border-dark-200 bg-dark-50 text-dark-900 text-sm focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-100 transition-all"
                    placeholder="email@adresa.com"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-dark-600 mb-2 text-left">
                  Broj telefona
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full px-5 py-3.5 rounded-xl border border-dark-200 bg-dark-50 text-dark-900 text-sm focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-100 transition-all"
                  placeholder="+381 6X XXXXXXX"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-dark-600 mb-2 text-left">
                  Poruka (opciono)
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  maxLength={500}
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  className="w-full px-5 py-3.5 rounded-xl border border-dark-200 bg-dark-50 text-dark-900 text-sm focus:outline-none focus:border-brand-400 focus:ring-2 focus:ring-brand-100 transition-all resize-none"
                  placeholder="Opišite šta vas zanima..."
                ></textarea>
                <p className="text-xs text-dark-400 mt-1 text-right">{formData.message.length}/500</p>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full sm:w-auto bg-brand-500 hover:bg-brand-600 text-white px-10 py-4 rounded-full text-base font-semibold transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer mx-auto disabled:opacity-50 shadow-lg shadow-brand-500/25"
              >
                {loading ? (
                  "Šalje se..."
                ) : (
                  <>
                    {ctaContent.button}
                    <i className="ri-arrow-right-line"></i>
                  </>
                )}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}